import { render, staticRenderFns } from "./blob_edit.vue?vue&type=template&id=c2f89fa2&"
import script from "./blob_edit.vue?vue&type=script&lang=js&"
export * from "./blob_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports